import './ProductCardSkeleton.css';

function SkeletonLine({ className = '' }) {
  return (
    <span
      className={`product-card-skeleton__line product-card-skeleton__shimmer ${className}`.trim()}
      aria-hidden="true"
    />
  );
}

export function ProductCardSkeleton({ layout = 'grid', compact = false }) {
  if (layout === 'list') {
    return (
      <article
        className="product-card product-card-skeleton product-card-skeleton--list"
        aria-hidden="true"
      >
        <div className="product-card-skeleton__media product-card-skeleton__shimmer" />
        <div className="product-card-skeleton__body">
          <SkeletonLine className="product-card-skeleton__line--title" />
          <SkeletonLine className="product-card-skeleton__line--title-short" />
          <SkeletonLine className="product-card-skeleton__line--price" />
          <SkeletonLine className="product-card-skeleton__line--meta" />
        </div>
      </article>
    );
  }

  const compactClass = compact ? ' product-card-skeleton--compact' : '';

  return (
    <article
      className={`product-card product-card-skeleton${compactClass}`}
      aria-hidden="true"
    >
      <div className="product-card-skeleton__media product-card-skeleton__shimmer" />
      <div className="product-card-skeleton__body">
        <SkeletonLine className="product-card-skeleton__line--title" />
        <SkeletonLine className="product-card-skeleton__line--title-short" />
        <SkeletonLine className="product-card-skeleton__line--price" />
        <SkeletonLine className="product-card-skeleton__line--meta" />
      </div>
    </article>
  );
}

export function ProductGridSkeleton({
  count,
  layout = 'grid',
  compact = false,
  gridClassName,
  cellClassName,
}) {
  const isList = layout === 'list';

  return (
    <>
      <span className="sr-only" role="status">
        Loading products
      </span>
      <ul
        className={gridClassName}
        aria-busy="true"
        aria-hidden="true"
      >
      {Array.from({ length: count }, (_, index) => (
        <li key={index} className={cellClassName}>
          <ProductCardSkeleton
            layout={isList ? 'list' : 'grid'}
            compact={compact && !isList}
          />
        </li>
      ))}
    </ul>
    </>
  );
}

const LANDING_CATEGORY_SKELETON_COUNT = 3;
const LANDING_PRODUCTS_PER_CATEGORY = 4;

/** Skeleton cell count that matches the final product grid layout. */
export function landingProductSkeletonCount(productCount) {
  const countNum = Number(productCount);
  if (!Number.isFinite(countNum) || countNum <= 0) {
    return 0;
  }
  if (countNum > 3) {
    return 4;
  }
  return countNum;
}

export function CategoryProductGridSkeleton({ count }) {
  if (count <= 0) {
    return null;
  }

  return (
    <ul
      className="landing-categories__grid landing-categories__mini-cards"
      aria-busy="true"
      aria-hidden="true"
    >
      {Array.from({ length: count }, (_, cellIndex) => (
        <li key={cellIndex} className="landing-categories__cell">
          <ProductCardSkeleton layout="grid" compact />
        </li>
      ))}
    </ul>
  );
}

export function CategoryListSkeletonSections() {
  return Array.from({ length: LANDING_CATEGORY_SKELETON_COUNT }, (_, sectionIndex) => (
    <section
      key={sectionIndex}
      className="landing-categories__section"
    >
      <header className="landing-categories__section-header">
        <span
          className="landing-categories__heading-skeleton product-card-skeleton__shimmer"
          aria-hidden="true"
        />
      </header>
      <ul className="landing-categories__grid landing-categories__mini-cards">
        {Array.from({ length: LANDING_PRODUCTS_PER_CATEGORY }, (_, cellIndex) => (
          <li key={cellIndex} className="landing-categories__cell">
            <ProductCardSkeleton layout="grid" compact />
          </li>
        ))}
      </ul>
    </section>
  ));
}

export function CategoryListSkeleton() {
  return (
    <>
      <span className="sr-only" role="status">
        Loading categories
      </span>
      <div
        className="landing-categories"
        aria-busy="true"
        aria-hidden="true"
      >
      {CategoryListSkeletonSections()}
    </div>
    </>
  );
}
